<template>
  <section>
    <table id="datatable" class="table table-striped table-responsive">
      <thead>
      <tr>
        <th width="22%"><span class="filter">Team Stats</span></th>
        <th class="text-center pl-0 pr-0" width="12%">
        <span class="filter" >
          <ClockIcon style="height: 14px; width: 15px; margin-bottom: 4px"/>
         Migrations
        </span>
        </th>
        <th width="15.2%" class="text-center">
        <span class="filter">
          <RandomSolidIcon style="height: 14px; width: 15px; margin-bottom: 4px"/>
          Monitors
        </span>
        </th>
        <th  class="text-center pl-0 pr-0" width="10%"><span class="filter">&#8623; Tasks</span></th>
        <th  class="text-center pl-0 pr-0" width="10%"><span class="filter">&#9734; Reviews</span></th>
        <th  class="text-center pl-0 pr-0" width="12%"><span class="filter">
        <ShieldHalvedIcon  style="height: 14px; width: 15px; margin-bottom: 4px"/>
        Perf&Sec
      </span>
        </th>
        <th  class="text-center pl-0 pr-0" width="12%"><span class="filter">
        <UserSolidIcon style="height: 14px; width: 15px; margin-bottom: 4px"/>
        Team Remarks
        <i @click="openModal('Team', [])" class="fa fa-plus-circle make-cursor-pointer"></i>
      </span>
        </th>
        <th  class="text-center pl-0 pr-0" width="10%"><span class="filter">
        <CommentIcon style="height: 14px; width: 15px; margin-bottom: 4px"/>
          NPS
        <i @click="openModal('Customer', [])" class="fa fa-plus-circle make-cursor-pointer"></i>
      </span>
        </th>
      </tr>
      </thead>
      <tbody>
      <template v-if="updatedArray.length">
        <tr v-for="(row, index) in updatedArray" :key="index" :class="{'logged-user-row': user.uid === row.uid }">
          <td style="" class="d-flex align-items-center">
            <div class="photo">
              <img :src="`https://www.gravatar.com/avatar/${md5(row.email.trim().toLowerCase())}?s=45`"/>
            </div>
            <div class="ml-6">
            <span class="ml-2 d-flex align-items-center justify-content-between">
              <span class="text-wrap" style="width: 70px">{{ row.name }}</span>
              <span :title="row.wins && row.wins.migration ? getTitle(row.wins.migration.monthArray) : ''" class="ml-6 make-cursor-pointer" :class="{'gold-image': topData.migration.length && row.uid === topData.migration[0].uid && row.migration !== 0,
               'silver-image': topData.migration.length && row.uid === topData.migration[1].uid && row.migration !== 0,
               'bronze-image': topData.migration.length && row.uid === topData.migration[2].uid && row.migration !== 0,}">
                <ClockIcon style="height: 14px; width: 15px; margin-bottom: 4px; margin-left: 10px"/>
              </span>
              <span :title="row.wins && row.wins.monitor ? getTitle(row.wins.monitor.monthArray) : ''" class="make-cursor-pointer" :class="{'gold-image': topData.monitor.length && row.uid === topData.monitor[0].uid && row.monitor !== 0,
               'silver-image': topData.monitor.length && row.uid === topData.monitor[1].uid && row.monitor !== 0,
               'bronze-image': topData.monitor.length && row.uid === topData.monitor[2].uid && row.monitor !== 0,}">
                <RandomSolidIcon style="height: 14px; width: 15px; margin-bottom: 4px; margin-left: 10px"/>
              </span>
              <span :title="row.wins && row.wins.support ? getTitle(row.wins.support.monthArray) : ''" :class="{'gold-image': topData.support.length && row.uid === topData.support[0].uid && row.support !== 0,
               'silver-image': topData.support.length && row.uid === topData.support[1].uid && row.support !== 0,
               'bronze-image': topData.support.length && row.uid === topData.support[2].uid && row.support !== 0,}" class="ml-10 fs-20 make-cursor-pointer">&#8623;</span>
              <span :title="row.wins && row.wins.review ? getTitle(row.wins.review.monthArray) : ''" :class="{'gold-image': topData.review.length && row.uid === topData.review[0].uid && row.review !== 0,
               'silver-image': topData.review.length && row.uid === topData.review[1].uid && row.review !== 0,
               'bronze-image': topData.review.length && row.uid === topData.review[2].uid && row.review !== 0,}" class="fs-24 ml-10 make-cursor-pointer">&#9734;
              </span>
                 <span :title="row.wins && row.wins.cfEnterprise ? getTitle(row.wins.cfEnterprise.monthArray) : ''" :class="{'gold-image': topData.cfEnterprise.length && row.uid === topData.cfEnterprise[0].uid && row.cfEnterprise !== 0,
               'silver-image': topData.cfEnterprise.length && row.uid === topData.cfEnterprise[1].uid && row.cfEnterprise !== 0,
               'bronze-image': topData.cfEnterprise.length && row.uid === topData.cfEnterprise[2].uid && row.cfEnterprise !== 0,}" class="fs-24 ml-10 make-cursor-pointer">
                <ShieldHalvedIcon style="height: 14px; width: 15px; margin-bottom: 4px;"/>
              </span>
              <span :title="row.wins && row.wins.teamRemarks ? getTitle(row.wins.teamRemarks.monthArray) : ''" class="make-cursor-pointer" :class="{'gold-image': topData.teamRemarks.length && row.uid === topData.teamRemarks[0].uid && row.teamRemarks !== 0,
               'silver-image': topData.teamRemarks.length && row.uid === topData.teamRemarks[1].uid && row.teamRemarks !== 0,
               'bronze-image': topData.teamRemarks.length && row.uid === topData.teamRemarks[2].uid && row.teamRemarks !== 0,}">
                <UserSolidIcon style="height: 14px; width: 15px; margin-bottom: 4px; margin-left: 10px"/>
              </span>
              <span :title="row.wins && row.wins.customerRemarks ? getTitle(row.wins.customerRemarks.monthArray) : ''" class="make-cursor-pointer" :class="{'gold-image': topData.customerRemarks.length && row.uid === topData.customerRemarks[0].uid && row.customerRemarks !== 0,
               'silver-image': topData.customerRemarks.length && row.uid === topData.customerRemarks[1].uid && row.customerRemarks !== 0,
               'bronze-image': topData.customerRemarks.length && row.uid === topData.customerRemarks[2].uid && row.customerRemarks !== 0,}">
               <CommentIcon style="height: 14px; width: 15px; margin-bottom: 4px ; margin-left: 10px"/>
              </span>
            </span>
            </div>
          </td>

          <td class="text-center">
            <div v-if="topData.migration.length && row.uid === topData.migration[0].uid && row.migration !== 0" class="position-relative d-flex align-items-center justify-content-center">
              <CrownGoldIcon style="height: 40px; width: 50px"/>
              <div class="position-absolute font-weight-bold mt-15">{{ row.migration }}</div>
            </div>
            <div v-else-if="topData.migration.length && row.uid === topData.migration[1].uid && row.migration !== 0" class="position-relative d-flex align-items-center justify-content-center">
              <SilverCrownIcon style="height: 40px; width: 50px"/>
              <div class="position-absolute font-weight-bold mt-15">{{ row.migration }}</div>
            </div>
            <div v-else-if="topData.migration.length && row.uid === topData.migration[2].uid && row.migration !== 0" class="position-relative d-flex align-items-center justify-content-center">
              <BronzeCrownIcon style="height: 40px; width: 50px"/>
              <div class="position-absolute font-weight-bold mt-15">{{ row.migration }}</div>
            </div>
            <span v-else>{{row.migration}}</span>
          </td>
          <td class="text-center">
            <div v-if="topData.monitor.length && row.uid === topData.monitor[0].uid && row.monitor !== 0" class="position-relative d-flex align-items-center justify-content-center">
              <CrownGoldIcon style="height: 40px; width: 50px"/>
              <div class="position-absolute font-weight-bold mt-15">{{ row.monitor }}</div>
            </div>
            <div v-else-if="topData.monitor.length && row.uid === topData.monitor[1].uid && row.monitor !== 0" class="position-relative d-flex align-items-center justify-content-center">
              <SilverCrownIcon style="height: 40px; width: 50px"/>
              <div class="position-absolute font-weight-bold mt-15">{{ row.monitor }}</div>
            </div>
            <div v-else-if="topData.monitor.length && row.uid === topData.monitor[2].uid && row.monitor !== 0" class="position-relative d-flex align-items-center justify-content-center">
              <BronzeCrownIcon style="height: 40px; width: 50px"/>
              <div class="position-absolute font-weight-bold mt-15">{{ row.monitor }}</div>
            </div>
            <span v-else>{{row.monitor}}</span>

          </td>
          <td class="text-center">
            <div v-if="topData.support.length && row.uid === topData.support[0].uid && row.support !== 0" class="position-relative d-flex align-items-center justify-content-center">
              <CrownGoldIcon style="height: 40px; width: 50px"/>
              <div class="position-absolute font-weight-bold mt-15">{{ row.support }}</div>
            </div>
            <div v-else-if="topData.support.length && row.uid === topData.support[1].uid && row.support !== 0" class="position-relative d-flex align-items-center justify-content-center">
              <SilverCrownIcon style="height: 40px; width: 50px"/>
              <div class="position-absolute font-weight-bold mt-15">{{ row.support }}</div>
            </div>
            <div v-else-if="topData.support.length && row.uid === topData.support[2].uid && row.support !== 0" class="position-relative d-flex align-items-center justify-content-center">
              <BronzeCrownIcon style="height: 40px; width: 50px"/>
              <div class="position-absolute font-weight-bold mt-15">{{ row.support }}</div>
            </div>
            <span v-else>{{row.support}}</span>
          </td>
          <td class="text-center">
            <div v-if="topData.review.length && row.uid === topData.review[0].uid && row.review !== 0" class="position-relative d-flex align-items-center justify-content-center">
              <CrownGoldIcon style="height: 40px; width: 50px"/>
              <div class="position-absolute font-weight-bold mt-15">{{ row.review }}</div>
            </div>
            <div v-else-if="topData.review.length && row.uid === topData.review[1].uid && row.review !== 0" class="position-relative d-flex align-items-center justify-content-center">
              <SilverCrownIcon style="height: 40px; width: 50px"/>
              <div class="position-absolute font-weight-bold mt-15">{{ row.review }}</div>
            </div>
            <div v-else-if="topData.review.length && row.uid === topData.review[2].uid && row.review !== 0" class="position-relative d-flex align-items-center justify-content-center">
              <BronzeCrownIcon style="height: 40px; width: 50px"/>
              <div class="position-absolute font-weight-bold mt-15">{{ row.review }}</div>
            </div>
            <span v-else>{{row.review}}</span>
          </td>
          <td class="text-center">
            <div v-if="topData.cfEnterprise.length && row.uid === topData.cfEnterprise[0].uid && row.cfEnterprise !== 0" class="position-relative d-flex align-items-center justify-content-center">
              <CrownGoldIcon style="height: 40px; width: 50px"/>
              <div class="position-absolute font-weight-bold mt-15">{{ row.cfEnterprise }}</div>
            </div>
            <div v-else-if="topData.cfEnterprise.length && row.uid === topData.cfEnterprise[1].uid && row.cfEnterprise !== 0" class="position-relative d-flex align-items-center justify-content-center">
              <SilverCrownIcon style="height: 40px; width: 50px"/>
              <div class="position-absolute font-weight-bold mt-15">{{ row.cfEnterprise }}</div>
            </div>
            <div v-else-if="topData.cfEnterprise.length && row.uid === topData.cfEnterprise[2].uid && row.cfEnterprise !== 0" class="position-relative d-flex align-items-center justify-content-center">
              <BronzeCrownIcon style="height: 40px; width: 50px"/>
              <div class="position-absolute font-weight-bold mt-15">{{ row.cfEnterprise }}</div>
            </div>
            <span v-else>{{row.cfEnterprise}}</span>
          </td>
          <td class="text-center">
            <div title="Click to check the team remarks" @click="openModal('View Team',  row.teamRemarksDetails)" v-if="topData.teamRemarks.length && row.uid === topData.teamRemarks[0].uid && row.teamRemarks !== 0" class="position-relative d-flex align-items-center justify-content-center">
              <CrownGoldIcon style="height: 40px; width: 50px"/>
              <div class="position-absolute font-weight-bold mt-15">{{ row.teamRemarks }}</div>
            </div>
            <div title="Click to check the team remarks" @click="openModal('View Team',  row.teamRemarksDetails)" v-else-if="topData.teamRemarks.length && row.uid === topData.teamRemarks[1].uid && row.teamRemarks !== 0" class="position-relative d-flex align-items-center justify-content-center">
              <SilverCrownIcon style="height: 40px; width: 50px"/>
              <div class="position-absolute font-weight-bold mt-15">{{ row.teamRemarks }}</div>
            </div>
            <div title="Click to check the team remarks" @click="openModal('View Team',  row.teamRemarksDetails)" v-else-if="topData.teamRemarks.length && row.uid === topData.teamRemarks[2].uid && row.teamRemarks !== 0" class="position-relative d-flex align-items-center justify-content-center">
              <BronzeCrownIcon style="height: 40px; width: 50px"/>
              <div class="position-absolute font-weight-bold mt-15">{{ row.teamRemarks }}</div>
            </div>
            <span title="Click to check the team remarks" @click="openModal('View Team',  row.teamRemarksDetails)" v-else class="make-cursor-pointer">{{row.teamRemarks}}</span>
          </td>
          <td class="text-center">
          <span :style="{ color: getColorFromScore(row.npsVal) }" title="Click to check the customer remarks" @click="openModal('View Customer', [], row)" class="make-cursor-pointer" ><b>{{ row.npsVal === 0 || row.npsVal ? row.npsVal : 'N/A' }} </b>
          <span :style="{ backgroundColor: getColorFromScore(row.npsVal) }" title="Total Reviews" class="badge noti-icon-badge ml-10">{{ getTotalRemarks(row.allCustRemarks) }}</span>
          </span>
          </td>
        </tr>
      </template>
      <template v-else>
        <tr>
          <td colspan="7">
            <div class="loader small_loader mt-12" v-if="loading"></div>
            <div v-else>
              <p class="text-center text-danger mb-3 font-weight-bold">No Data Exists</p>
            </div>
          </td>
        </tr>
      </template>
      </tbody>
      <tfoot>
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>
          <div class="d-flex justify-content-end align-items-center" >
          <span>
            <strong >Total NPS Score: <span :style="{ color: getColorFromScore(totalNpsScore) }">{{totalNpsScore === 0 || totalNpsScore ? totalNpsScore : 'N/A'}}  </span></strong>
            <span :style="{ backgroundColor: getColorFromScore(totalNpsScore) }" title="Total Reviews" class="badge noti-icon-badge ml-10">{{ getAllRemarksCount() }}</span>
          </span>
          </div>
          <div class="d-flex justify-content-end">
            <button v-show="!exportClicked" @click="exportNps()" type="button" style="width: 185px" :disabled="exportLoading" class="btn btn-primary btn-sm mr-4 d-flex justify-content-center">
              <div v-if="exportLoading" class="loader mini_loader"></div><span v-else class="">Export Data</span>
            </button>
            <vue-json-to-csv v-show="exportClicked" :json-data="npsJson" :labels="labels" :csv-title="getTitleForCsv()">
              <button id="export" type="button" style="width: 185px" :disabled="exportLoading" class="btn btn-primary btn-sm mr-4">
                Export Data
              </button>
            </vue-json-to-csv>
          </div>
        </td>
      </tr>
      </tfoot>

    </table>
  </section>
</template>

<script>
import {db} from "@/firebase/init";
import VueJsonToCsv from 'vue-json-to-csv'
import moment from 'moment';
import md5 from "crypto-js/md5";
import ClockIcon from "@/assets/icons/font-awesomeV5/ClockIcon.vue";
import RandomSolidIcon from "@/assets/icons/font-awesomeV5/RandomSolidICon.vue";
import UserSolidIcon from "@/assets/icons/font-awesomeV5/UserSolidIcon.vue";
import CommentIcon from "@/assets/icons/font-awesomeV5/CommentIcon.vue";
import CrownGoldIcon from "@/assets/icons/font-awesomeV5/crown/GoldCrown.vue";
import SilverCrownIcon from "@/assets/icons/font-awesomeV5/crown/SilverCrown.vue";
import BronzeCrownIcon from "@/assets/icons/font-awesomeV5/crown/bronzeCrown.vue";
import ShieldHalvedIcon from "@/assets/icons/font-awesomeV5/shieldHalvedIcon.vue";
export default {
  name: "teamStats",
  components: {
    ShieldHalvedIcon,
    BronzeCrownIcon,
    SilverCrownIcon, CrownGoldIcon, CommentIcon, UserSolidIcon, RandomSolidIcon, ClockIcon, VueJsonToCsv},
  props: {
    users: {
      type: Array,
    },
    loading: {
      type: Boolean
    },
    topData: {
      type: Object
    },
    allTimeLeaderboardData: {
      type: Array
    },
    totalNpsScore:{
      type: Number
    }
  },
  data() {
    return {
      npsJson: [],
      labels: {},
      exportLoading: false,
      exportClicked: false
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    updatedArray(){
      for (const row of this.users) {
        const obj = this.allTimeLeaderboardData.find(el => el.uid === row.uid);
        if (obj) {
          row.wins = obj.wins
        }
      }
      console.log('all users', this.users)
      let users = []
      if(this.user.email.includes('@septemsystems.com')){
        users = this.users.filter(el => !el.email.includes('@septemsystems.com'))
      } else {
        users = this.users.filter(el => !el.email.includes('@septemsystems.com'))
        users = [users.find(el => el.uid === this.user.uid), ...users.filter(el => el.uid !== this.user.uid)]
      }
      return users
    },
  },
  beforeDestroy() {
    $("#datatable").DataTable().destroy();
  },
  methods: {
    md5,
    getTitleForCsv(){
      return `NPS Reviews_${(new Date()).getTime()}`
    },
    async exportNps(val){
      try {
        console.log('im called', val)
        this.exportLoading = true
        const allCustRemarks = [];
        let ref= await db.collection('customerRemarks').where('status', '==', 'completed').get();
        ref.forEach(el => {
          allCustRemarks.push({id: el.id, ...el.data()});
        })
        const allUsers = JSON.parse(JSON.stringify(this.users))
        for (const row of allUsers) {
          row.allCustRemarks = [];
          row.allCustRemarks = allCustRemarks.filter(el => el.staffMemberDetails.uid === row.uid);
          row.npsVal = await this.calcNps(row.allCustRemarks);
          let staffName = null
          for(const row1 of row.allCustRemarks){
            staffName = row1.staffMemberDetails ? row1.staffMemberDetails.name : ''
            this.npsJson.push({ date: row1.createdAt ? moment(row1.createdAt).format('DD MMM YYYY, hh:mm a') : '', clientName: row1.commentGivenBy ? row1.commentGivenBy.name || '' : '', comment: row1.comment || '', rating: row1.reaction,  ticketId: row1.ticketId || 'Link Generated', staffName: row1.staffMemberDetails ? row1.staffMemberDetails.name || '' : '', npsVal: '',})
          }
          if(row.allCustRemarks && row.allCustRemarks.length) {
            this.npsJson.push({date: '', clientName: '', comment: '', rating: '', ticketId: '', staffName: '', npsVal: `NPS Score of ${staffName}: ${row.npsVal || 0}`})
          }
        }
        this.labels = {
          date: { title: 'Date' },
          clientName: { title: 'Client Name' },
          comment: {title: 'Comment'},
          rating: { title: 'Rating' },
          ticketId: { title: 'Ticket ID' },
          staffName: { title: 'Staff Name' },
          npsVal: {title: 'NPS Score'},
        }
        this.exportClicked = true;
        setTimeout(function() {
          const button = document.getElementById("export");
          button.click();
          this.exportClicked = false
        }, 500);
      } catch (e) {
        this.exportLoading = false
        console.log('error 273', e.toString())
      } finally {
        this.exportLoading = false
        this.exportClicked = false
      }
    },
    calcNps(allCustRemarks){
      let npsVal = null;
      let promotor = 0;
      let detractor = 0;
      if (allCustRemarks.length) {
        // get those which are latest
        const latestFeedbacks = allCustRemarks.filter(el => el.latestFeedback && (el.status ? el.status === 'completed' : true));
        console.log('latestFeed', latestFeedbacks)
        latestFeedbacks.map(el => {
          if (el.reaction === 'excellent') {
            promotor += 1;
          } else if (el.reaction === 'hate') {
            detractor += 1;
          }
        })
        npsVal =  Math.round(((promotor / latestFeedbacks.length)*100) - ((detractor / latestFeedbacks.length) * 100));
      } else {
        npsVal = null;
      }
      return npsVal;
    },
    getAllRemarksCount () {
      let totalCount = 0;
      this.updatedArray.map(el => {
        totalCount += this.getTotalRemarks(el.allCustRemarks)
      })
      return totalCount
    },
    getTotalRemarks(remarks = []){
      if (remarks.length === 0) {
        return 0
      }
      return (remarks.filter(el => el.latestFeedback)).length
    },
    getColorFromScore (score) {
      if (score !== 0 &&   !score) {
        return
      }
      if (score < 0) {
        return 'red';
      } else if (score <= 25) {
        return 'rgb(241 138 10)';
      } else {
        return 'green';
      }
    },
    getTitle (array) {
      let string = '';
      if(array.length) {
        for(const row of array) {
          let date = new Date()
          date.setMonth(row.month)
          const month = date.toLocaleString('en-US', { month: 'short' })
          string += `Month: ${month} | Award: ${row.award}, `
        }
      }
      return string;
    },
    async openModal(type, selectedTeamRemarks, row) {
      console.log('357', row)
      let selectedCustomerRemarks = []
      if(type === 'View Team' && !selectedTeamRemarks.length){
        return
      }
      else if(type === 'View Customer') {
        if (!row.allCustRemarks.length) {
          return
        }
        selectedCustomerRemarks = row.allCustRemarks;
        // const month = this.$parent.month
        // let ref= db.collection('customerRemarks').where('staffMemberDetails.uid', '==', row.uid).where('status', '==', 'completed')
        // if(month === 'all') {
        //   ref= await ref.get();
        // }
        // else {
        //   ref= await ref.where('month', '==', month).get()
        // }
        // ref.forEach(el => {
        //   selectedCustomerRemarks.push({id: el.id, ...el.data()})
        // })
        console.log('customer remarks', selectedCustomerRemarks)
      }
      this.$emit('openModal', {type, selectedTeamRemarks, selectedCustomerRemarks})
    },
    renderTable() {
      console.log('datatable')
      // console.log('before', $.fn.DataTable.isDataTable( '#datatable' ))
      if($.fn.DataTable.isDataTable( '#datatable' )){
        $("#datatable").DataTable().destroy();
      }
      setTimeout(()=>{
          $(`#datatable`).dataTable({
            paging: false,
            'columnDefs': [ {
              'targets': [0], // column index (start from 0)
              'orderable': false, // set orderable false for selected columns
            }],
            aaSorting: [],
            order: [],
            bFilter: false,
            lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]],
            retrieve: true,
            ordering: true,
            'destroy'     : true,
          });
        },300)
        $('.filter').on('click', function(e){
          e.stopPropagation();
        });


        console.log('after', $.fn.DataTable.isDataTable( '#datatable' ))

    }
  }
}
</script>

<style scoped>
.icon-style{
  height: 16px;
}
.fa-fire-alt {
  background: conic-gradient(from -45deg, #ED4C20 110deg, #ED4C20 90deg 180deg, #FBBB16 180deg 270deg, #FBBB16 270deg) 73% 55%/150% 150% no-repeat;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
}
.silver-crown {
  background: conic-gradient(from -45deg, #DEDEDE 110deg, #DEDEDE 90deg 180deg, #CECECE 180deg 270deg, #CECECE 270deg) 73% 55%/150% 150% no-repeat;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
}
.gold-crown{
  background: conic-gradient(from -45deg, #F0BD02 110deg, #F0BD02 90deg 180deg, #F2D507 180deg 270deg, #F2D507 270deg) 73% 55%/150% 150% no-repeat;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
}
.ml-39{
  margin-left: -39px;
}
.bronze-crown{
  background: conic-gradient(from -45deg, #9D6015 110deg, #9D6015 90deg 180deg, #834C16 180deg 270deg, #834C16 270deg) 73% 55%/150% 150% no-repeat;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
}
.fa-plus-circle{
  color: #AAE6E0;
}
.logged-user-row{
  background: #FFFAEC !important;
}
.fs-24{
  font-size: 24px;
}
.z-index
{
  z-index: 1;
}
.avatar-h-w{
  height: 49px;
  width: 49px;
  margin-bottom: 0px;
}
.gold-image{
  color: #F0BD02
}
.silver-image{
  color: #E0E0E0
}
.bronze-image{
  color: #9D6015

}
img {
  border-radius: 50%;
}
.fs-20 {
  font-size: 20px;
}
</style>
